import { createAction } from 'redux-actions';

export const TOGGLE_ASIDE = 'TOGGLE_ASIDE';
export const toggleAside = createAction(TOGGLE_ASIDE);



// WEBPACK FOOTER //
// ./src/app/shared/stores/ui.actions.js